import "./Partners.scss";

const partnersLinks = [
    { name: "UCU", link: "https://ucu.edu.ua/en/", logo: "/partners/ucu.svg" },
    { name: "APPS", link: "https://apps.ucu.edu.ua/en/", logo: "/partners/apps.svg" },
    { name: "Nova Ukraine", link: "https://novaukraine.org/",  logo: "/partners/novaukraine.svg" },
    { name: "Eleks", link: "https://eleks.com/", logo: "/partners/eleks.svg" },
    { name: "Infineon", link: "https://www.infineon.com/", logo: "/partners/infineon.svg" },
    { name: "SoftServe", link: "https://www.softserveinc.com/en-us", logo: "/partners/softserve.svg" }
];

const Partners = ({id}) => {
    return(
        <section className="Partners" id={id}>
            <div className="Partners-txt">
                <h2>PARTNERS</h2>
                <p className="Partners-txt-p">who believe and support along the way</p>
            </div>
            <div className="Partners-list">
                {partnersLinks.map((partner, i) => (
                    <a className="Partners-list-link" href={partner.link} key={i}><img key={i} src={partner.logo} alt={partner.name}/></a>
                ))}
            </div>
        </section>
    )
}
export default Partners;